module.exports = __webpack_public_path__ + "43da783ef7600b7bada6b923f7e9c547.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/logos/JabJab-Cuisine-logo.jpg
// module id = 648
// module chunks = 0